export const LogType  = {
  ADVERTISER: 'ADVERTISER',
  PUBLISHER: 'PUBLISHER',
  ACCOUNT: 'ACCOUNT',
  ORGANIZATION: 'ORGANIZATION',
} as const;

export type LogType = keyof typeof LogType;
